<template>
  <div class="p-3 bg-white">
    <shared-task-add
      @addTaskSuccess="addTaskSuccess"
      :categoryOptions="categoryOptions"
      :progressStatusOptions="progressStatusOptions"
      :priorityOptions="priorityOptions"
      :visibilityOptions="visibilityOptions"
      :userOptions="userOptions"
      :projectOptions="projectOptions"
    ></shared-task-add>

    <div class="text-center">
      <vs-button id="addTaskButton" class="m-2" color="primary" type="filled" @click.prevent="addTask">{{ $t('save') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelAddTask">{{ $t('cancel') }}</vs-button>
    </div>
  </div>
</template>

<script>
import Task from '@/models/Task'
import SharedTaskAdd from '@/views/Shared/Tasks/Add'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.Task.Add',
  components: {
    SharedTaskAdd
  },
  data () {
    return {
      categoryOptions: [],
      progressStatusOptions: [],
      priorityOptions: [],
      visibilityOptions: [],
      userOptions: [],
      projectOptions: []
    }
  },
  mounted () {
    this.loadTasks()
  },
  methods: {
    async loadTasks (page) {
      const response = await Task.findAll({ ...this.taskSearchParams, page })
      this.categoryOptions = response.data.meta.options.categories
      this.progressStatusOptions = response.data.meta.options.progressStatuses
      this.priorityOptions = response.data.meta.options.priorities
      this.visibilityOptions = response.data.meta.options.visibilities
      this.userOptions = response.data.meta.options.users
      this.projectOptions = response.data.meta.options.projects
    },
    addTask () {
      EventBus.$emit('initAddTask')
    },
    addTaskSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_task_table')
      window.close()
    },
    cancelAddTask () {
      this.$windowOpenerHelper.notifyOpener('reload_task_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
